<template>
	<div
		class="floating-label-input"
		:class="{ 'floating-label-input--error': error }"
	>
		<input
			:type="type"
			:id="id"
			:name="name"
			:placeholder="label"
			v-model="innerValue"
		/>
		<label :for="id">
			{{ label }}
		</label>
		<div class="error" v-show="error">{{ error }}</div>
	</div>
</template>

<script>
export default {
	props: {
		type: {
			type: String,
			required: true
		},
		name: {
			type: String,
			required: false
		},
		label: {
			type: String,
			required: true
		},
		value: {
			type: String,
			required: false
		},
		error: {
			type: String,
			required: false
		}
	},
	data() {
		return {
			innerValue: this.value,
			rndId: Math.random()
				.toString()
				.replace(".", "")
		};
	},
	computed: {
		id() {
			let id = "fl-";
			if (this.name) {
				id += this.name + "-";
			}
			return (id += this.rndId);
		}
	},
	watch: {
		innerValue(val) {
			this.$emit("input", val);
		}
	}
};
</script>

<style lang="scss" scoped>
.error {
	margin-top: 8px;
}
</style>